import interpolate, {
  type TranslateFn,
  type TranslationOptions,
} from "@app/_utils/interpolate";
import { use, useCallback } from "react";
import type { Dictionary } from "types/common";
import { TranslationContext } from "../_context/translationContext";

export type { TranslateFn, TranslationOptions };

const EMPTY_DICTIONARY: Dictionary = {};

export default function useTranslate(): TranslateFn {
  const translations = use(TranslationContext);

  return useCallback(
    ((key: string, options?: TranslationOptions<boolean>) => {
      if (!translations) {
        return key;
      }

      if (options?.strict) return translations[key];
      const translation = translations[key] ?? `!${key}`;
      return interpolate(translation, options as TranslationOptions<false>);
    }) as TranslateFn,
    [translations],
  );
}

export function useTranslationMap(): Dictionary {
  return (use(TranslationContext) ?? EMPTY_DICTIONARY) as Dictionary;
}
